import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import { TOP } from 'app/analytics/constants/positions';
import ProductCta from 'app/features/landing/components/ProductCta';
import { buttonTextKey } from 'app/features/landing/heroBlock/selectors';
import {
  isMultiTier,
  firstPaidProductSku,
} from 'app/features/products/selectors';

const UI = ({ textKey, sku, isMultiTier }) => (
  <ProductCta
    sku={sku}
    textKey={textKey}
    testId="hero-block-button"
    isUpsell={isMultiTier}
    isWideOnMobile
    position={TOP}
  >
    <FormattedMessage id={`${textKey}`} />
  </ProductCta>
);

UI.propTypes = {
  textKey: PropTypes.string.isRequired,
  isMultiTier: PropTypes.bool.isRequired,
  sku: PropTypes.string.isRequired,
};

UI.displayName = 'HeroBlockProductCta';

const state = {
  sku: firstPaidProductSku,
  textKey: buttonTextKey,
  isMultiTier,
};

const HeroBlockProductCta = connect(state)(UI);

export { UI };

export default HeroBlockProductCta;
